<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">INV No 情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          v-if="!cantEdit"
          :disabled="
            !(bl.hasUpdated || (!bl.hasUpdated && bl.invoices.length < 1))
          "
          @click="addInvoice()"
          >追加</v-btn
        >
        <v-btn
          v-if="!cantEdit"
          :disabled="selected.length !== 1"
          @click="editInvoice()"
          >編集</v-btn
        >
        <v-btn
          v-if="!cantEdit"
          :disabled="selected.length === 0"
          @click="removeInv()"
          >削除</v-btn
        >
        <tdoc-file-upload
          v-if="!cantEdit"
          :disabled="selected.length !== 1"
          @addAttachment="addAttachment"
          style="margin:0px 15px;"
          type="INVOICE"
          :id="this.selected[0] && selected[0].id"
          title="UPLOAD INVOICE PDF"
        ></tdoc-file-upload>
      </v-card-actions>

      <v-data-table
        :headers="headers"
        :items="bl.invoices"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="invNo"
        :select-all="!cantEdit"
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td v-if="!cantEdit">
              <v-checkbox
                hide-details
                primary
                v-model="props.selected"
              ></v-checkbox>
            </td>

            <td v-for="(header, index) in headers" :key="index">
              {{ props.item[header.value] }}
            </td>
          </tr>
          <tr>
            <template>
              <td></td>
              <td colspan="5">
                <ul class="doc">
                  <li v-for="file in props.item.attachments" :key="file.name">
                    <div @click="$downloadTdocFile(file)">{{ file.name }}</div>
                    <span
                      v-if="!cantEdit"
                      @click="removeFile(file)"
                      class="material-icons del-btn"
                    >
                      delete_outline
                    </span>
                  </li>
                </ul>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <add-invoice-dialog
      :hasUpdated="bl.hasUpdated"
      :isJp="isJp"
      ref="addInvoiceDialog"
    />
  </v-container>
</template>

<script>
import AddInvoiceDialog from './AddInvoiceDialog.vue'

export default {
  components: {
    AddInvoiceDialog,
  },
  props: ['bl', 'isJp', 'cantEdit'],
  data() {
    return {
      headers: [
        {
          text: 'INV No',
          value: 'invNo',
          sortable: false,
        },
        {
          text: 'SEC Ref  No',
          value: 'secRefNo',
          sortable: false,
        },
        {
          text: 'BOOK No',
          value: 'bkNo',
          sortable: false,
        },
        {
          text: 'E/D No',
          value: 'edNo',
          sortable: false,
        },
        {
          text: 'S/I No',
          value: 'siNo',
          sortable: false,
        },
      ],
      selected: [],
    }
  },
  methods: {
    addInvoice() {
      this.$refs.addInvoiceDialog.popup().then((invoice) => {
        console.log(invoice)
        if (!this.bl.invoices) {
          this.bl.invoices = []
        }
        if (
          this.bl.invoices.map((i) => i.invNo).indexOf(invoice.invNo) !== -1
        ) {
          this.$message('', 'INV.NO重複で登録できません')
          return
        }
        this.bl.invoices = [...this.bl.invoices, invoice]
        this.$forceUpdate()
      })
    },
    editInvoice() {
      this.$refs.addInvoiceDialog.editInvoice(this.selected[0])
    },
    validInvAttachmentDump(attachment) {
      if (!this.selected[0].attachments) {
        this.selected[0].attachments = []
      }
      if (
        this.selected[0].attachments
          .map((a) => a.name)
          .indexOf(attachment.name) !== -1
      ) {
        return true
      }
      return false
    },
    addAttachment(attachment) {
      if (this.validInvAttachmentDump(attachment)) {
        this.$message('', 'InvoiceのPDFファイル名が重複しています。')
        return
      }
      this.selected[0].attachments.push(attachment)
      this.$forceUpdate()
      this.$emit('refreshInvAttachmentDate')
    },
    removeFile(file) {
      this.bl.invoices.forEach((inv) => {
        inv.attachments.forEach((attachment, index) => {
          if (attachment.fileOssId === file.fileOssId) {
            inv.attachments.splice(index, 1)
            this.$emit('refreshInvAttachmentDate')
            this.$forceUpdate()
          }
        })
      })
    },
    removeInv() {
      this.selected.forEach((s) => {
        this.bl.invoices.forEach((inv, index) => {
          if (inv.invNo === s.invNo) {
            this.bl.invoices.splice(index, 1)
          }
        })
      })
      this.selected = []
    },
  },
}
</script>

<style scoped>
.doc {
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  padding: 5px 0px;
}

.doc li {
  padding: 0px 15px 0px 25px;
  list-style: none;
  background: transparent url(../../assets/img/pdf.svg) no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

.del-btn {
  margin-left: 10px;
  color: #666;
  cursor: pointer;
}
</style>
